// mparle-facets.js — collectie-filters (desktop sidebar + mobile bottom-sheet)
//
// Desktop: change in sidebar = direct navigeren (zoals altijd).
// Mobile: change in sheet = pre-fetch nieuwe count via Section Rendering API,
//         pas bij "Toon N producten" navigeert de browser daadwerkelijk.
//         Dat voorkomt disoriënterende re-renders tijdens het filteren.

(function () {
  const root = document.querySelector('[data-mp-collection]');
  if (!root) return;

  const sheet = root.querySelector('[data-mp-facets-sheet]');
  const sheetForm = root.querySelector('[data-mp-facets-form]');
  const applyBtn = root.querySelector('[data-mp-facets-apply]');
  const ctaCount = root.querySelector('[data-mp-cta-count]');
  const trigger = root.querySelector('[data-mp-facets-open]');
  const sortSelect = root.querySelector('[data-mp-sort]');

  // ── Helpers: navigeer met huidige URL + nieuwe param ──────────
  function navigateWith(updates) {
    const url = new URL(window.location.href);
    for (const [k, v] of Object.entries(updates)) {
      if (v == null || v === '') url.searchParams.delete(k);
      else url.searchParams.set(k, v);
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function toggleParam(key, value, checked) {
    const url = new URL(window.location.href);
    const all = url.searchParams.getAll(key);
    url.searchParams.delete(key);
    const next = checked ? [...all.filter((v) => v !== value), value] : all.filter((v) => v !== value);
    next.forEach((v) => url.searchParams.append(key, v));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  // ── Desktop top-bar dropdowns ────────────────────────────────
  const dropdowns = root.querySelectorAll('[data-mp-dropdown]');
  dropdowns.forEach((dd) => {
    const btn = dd.querySelector('[data-mp-dropdown-trigger]');
    const panel = dd.querySelector('[data-mp-dropdown-panel]');
    if (!btn || !panel) return;

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const wasOpen = btn.getAttribute('aria-expanded') === 'true';
      // Sluit alle andere dropdowns
      dropdowns.forEach((other) => {
        if (other !== dd) {
          other.querySelector('[data-mp-dropdown-trigger]')?.setAttribute('aria-expanded', 'false');
          other.querySelector('[data-mp-dropdown-panel]')?.setAttribute('hidden', '');
        }
      });
      if (wasOpen) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });

    // Filter-changes in popover: direct navigeren
    panel.querySelectorAll('input[type=checkbox]').forEach((input) => {
      input.addEventListener('change', () => {
        toggleParam(input.name, input.value, input.checked);
      });
    });
    panel.querySelectorAll('input[type=number]').forEach((input) => {
      input.addEventListener('change', () => {
        navigateWith({ [input.name]: input.value });
      });
    });
  });

  // Click buiten een dropdown → sluit alles
  document.addEventListener('click', (e) => {
    dropdowns.forEach((dd) => {
      if (!dd.contains(e.target)) {
        dd.querySelector('[data-mp-dropdown-trigger]')?.setAttribute('aria-expanded', 'false');
        dd.querySelector('[data-mp-dropdown-panel]')?.setAttribute('hidden', '');
      }
    });
  });

  // Escape: sluit alle dropdowns
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      dropdowns.forEach((dd) => {
        dd.querySelector('[data-mp-dropdown-trigger]')?.setAttribute('aria-expanded', 'false');
        dd.querySelector('[data-mp-dropdown-panel]')?.setAttribute('hidden', '');
      });
    }
  });

  // Desktop sort: replace URL met sort_by param
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      navigateWith({ sort_by: e.target.value });
    });
  }

  if (!sheet || !sheetForm) return;

  // ── Bottom-sheet open/close ───────────────────────────────────
  function openSheet() {
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    document.body.classList.add('mp-has-facets-sheet');
  }
  function closeSheet() {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mp-has-facets-sheet');
    setTimeout(() => { sheet.hidden = true; }, 300);
  }

  trigger?.addEventListener('click', (e) => {
    e.preventDefault();
    openSheet();
  });
  sheet.querySelectorAll('[data-mp-facets-close]').forEach((el) =>
    el.addEventListener('click', (e) => { e.preventDefault(); closeSheet(); })
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
  });

  // ── Live count via Section Rendering API ──────────────────────
  function buildUrl(extra) {
    const data = new FormData(sheetForm);
    const params = new URLSearchParams();
    for (const [k, v] of data.entries()) {
      if (v == null || v === '') continue;
      params.append(k, v);
    }
    if (extra) {
      for (const [k, v] of Object.entries(extra)) params.set(k, v);
    }
    return params;
  }

  let inflight = null;
  async function refreshCount() {
    const params = buildUrl();
    const url = `${window.location.pathname}?${params.toString()}`;

    if (inflight) inflight.abort();
    const controller = new AbortController();
    inflight = controller;

    try {
      // Full-page fetch — Section Rendering API werkt niet betrouwbaar voor
      // paginate-secties. Pluk het count-element uit de complete HTML.
      const res = await fetch(url, { signal: controller.signal, headers: { 'X-Requested-With': 'fetch' } });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCountEl = doc.querySelector('[data-mp-result-count]');
      if (newCountEl && ctaCount) {
        const match = newCountEl.textContent.trim().match(/\d+/);
        if (match) ctaCount.textContent = match[0];
      }
    } catch (err) {
      if (err.name !== 'AbortError') console.warn('facet refresh failed', err);
    } finally {
      if (inflight === controller) inflight = null;
    }
  }

  let debounceT = null;
  function scheduleRefresh() {
    clearTimeout(debounceT);
    debounceT = setTimeout(refreshCount, 220);
  }

  sheetForm.addEventListener('change', scheduleRefresh);
  sheetForm.addEventListener('input', (e) => {
    if (e.target.type === 'number') scheduleRefresh();
  });

  // ── Apply: navigeer naar de nieuwe URL ────────────────────────
  applyBtn?.addEventListener('click', () => {
    const params = buildUrl();
    const qs = params.toString();
    window.location.href = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  });
})();
